module.exports = __webpack_public_path__ + "static/media/fig_1_AB.7fa9592c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_1_AB.jpg
// module id = 650
// module chunks = 0